import { uiConstants } from '../constants/uiConstants';

const initialState = {
  pageTitle: '',
};

export default function ui(state = initialState, action) {
  switch (action.type) {
    case uiConstants.SET_PAGE_TITLE:
      return {
        ...state,
        pageTitle: action.name,
      };
    default:
      return state;
  }
}
